import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const RefreshKey = 'Refresh-Token'
const ONE_DAY = 1
const SEVEN_DAYS = 7
const THIRTY_DAYS = 30

function isSecureCookieContext() {
  if (typeof window !== 'undefined' && window.location) {
    return window.location.protocol === 'https:'
  }

  return process.env.NODE_ENV === 'production'
}

function buildCookieOptions(expires) {
  return {
    expires,
    sameSite: 'Lax',
    secure: isSecureCookieContext()
  }
}

function buildCookieRemovalOptions() {
  return {
    sameSite: 'Lax',
    secure: isSecureCookieContext()
  }
}

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, buildCookieOptions(ONE_DAY))
}

export function removeToken() {
  return Cookies.remove(TokenKey, buildCookieRemovalOptions())
}

export function getRefreshToken() {
  return Cookies.get(RefreshKey)
}

export function setRefreshToken(token) {
  return Cookies.set(RefreshKey, token, buildCookieOptions(SEVEN_DAYS))
}

export function removeRefreshToken() {
  return Cookies.remove(RefreshKey, buildCookieRemovalOptions())
}

export function setBusinessKYC(flag) {
  return Cookies.set('BusinessKYC', flag, buildCookieOptions(THIRTY_DAYS))
}
export function setPersonalKYC(flag) {
  return Cookies.set('PersonalKYC', flag, buildCookieOptions(THIRTY_DAYS))
}
export function getBusinessKYC() {
  return Cookies.get('BusinessKYC')
}
export function getPersonalKYC() {
  return Cookies.get('PersonalKYC')
}
export function getChainId() {
  return Cookies.get('TREASURE_CHAINID')
}

export function setChainId(data) {
  return Cookies.set('TREASURE_CHAINID', data, buildCookieOptions(THIRTY_DAYS))
}
